import { createContext } from 'react';

const VerificationContext = createContext(void 0);

VerificationContext.displayName = 'context(verification)';

export default VerificationContext;